module.exports = "<div class=\"page-header-fixed\">\n    <div class=\"header navbar navbar-inverse navbar-fixed-top\" ui-view=\"header\" data-role=\"navigation\"></div>\n    <div class=\"page-container\">\n        <!-- SIDEBAR -->\n        <div class=\"page-sidebar nav-collapse collapse\">\n            <div ui-view=\"sidebar\"></div>\n        </div>\n        <div ui-view></div>\n    </div>\n\n    <div class='footer'>\n        <div class='footer-inner'>\n            <section copyright id=\"support-button\"></section>\n            <!--| <a ng-href=\"/changelog\" style=\"color:#999999\"> Change Log </a>-->\n        </div>\n    </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/main/main.html
 ** module id = 445
 ** module chunks = 0
 **/